import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { MetricName } from '/@/modules/metric/constants/MetricName';
import { GTMEvent } from '/@/integrations/googletagmanager/constants/GTMEvent';
import { HotjarMetricEventDataLayerItem } from '/@/integrations/googletagmanager/models/HotjarMetricEventDataLayerItem';

export class Metric extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  type;

  /**
   * @var {mixed}
   */
  value;

  /**
   * @var {?Estate}
   */
  estate;

  /**
   * @var {?EstateAccount}
   */
  estateAccount;

  /**
   * @var {?User}
   */
  user;

  constructor(model = {}) {
    super(model);
    super.setRelationships(this, model, this.getModelName());

    this.id = model.id;
    this.name = model.name;
    this.type = model.type;
    this.value = model.value;
  }

  /**
   *
   * @returns {string}
   */
  getModelName() {
    return ModelType.METRIC;
  }

  get canTriggerEvent() {
    return MetricName.getByKey(this.name).triggerValue === this.value;
  }

  get hotjarMetricEventDataLayerItem() {
    return new HotjarMetricEventDataLayerItem({
      event: GTMEvent.METRIC_UPDATE,
      metricName: this.name
    });
  }
}
